import { fetchError, fetchStart, fetchSuccess } from '../../../redux/actions';
import { setAuthUser, setForgetPassMailSent, updateLoadUser } from '../../../redux/actions/Auth';
import React from 'react';
import axios from './config';

const JWTAuth = {
  onRegister: ({ name, email, password }) => {
    return dispatch => {
      dispatch(fetchStart());
      axios
        .post('auth/register', {
          email: email,
          password: password,
          name: name,
        })
        .then(({ data }) => {
          if (data.result) {
            localStorage.setItem('token', data.token.access_token);
            dispatch(fetchSuccess());
            dispatch(JWTAuth.getAuthUser(true, data.token.access_token));
          } else {
            dispatch(fetchError(data.error));
          }
        })
        .catch(function (error) {
          dispatch(fetchError(error.message));
        });
    };
  },

  onLogin: ({ email, password }) => {
    return dispatch => {
      try {
        dispatch(fetchStart());
        axios
          .post('login', {
            username: email,
            password: password,
            grant_type: 'password',
            scope: '',
            client_id: 2,
            client_secret: 'p4lJYB3dT6NQNeZmaxPltP5E40H8oepnzWqfscnG',
          })
          .then(({ data }) => {
            if (data) {
              localStorage.setItem('token', data.access_token);
              dispatch(fetchSuccess());
              dispatch(JWTAuth.getAuthUser(true, data.access_token)); // getAuthUser é uma ação que atualiza os dados de usuário no store.
            } else {
              dispatch(fetchError(data.message));
            }
          })
          .catch(function (error) {
            dispatch(fetchError(error.message));
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },

  onLogout: () => {
    return dispatch => {
      localStorage.removeItem('token');
      dispatch(setAuthUser(null));
    };
  },

  getAuthUser: (loaded = false, token = null) => {
    return dispatch => {
      if (!token) {
        token = localStorage.getItem('token');
      }
      if (!token) {
        dispatch(updateLoadUser(true));
        return;
      }

      dispatch(fetchStart());
      dispatch(updateLoadUser(loaded));
      axios
        .get(`atendente/user/info`, {
          headers: {
            'Authorization': `Bearer ${token || localStorage.getItem('token')}`,
          }
        })
        .then(({ data }) => {
          if (data.success) {
            dispatch(fetchSuccess());
            dispatch(setAuthUser(data.user));
          } else {
            dispatch(updateLoadUser(true));
            dispatch(fetchError('Credenciais não encontradas...'));
          }
        })
        .catch(function (error) {
          dispatch(updateLoadUser(true));
          dispatch(fetchError('Autenticação falhou...'));
        });
    };
  },

  onForgotPassword: () => {
    return dispatch => {
      dispatch(fetchStart());

      setTimeout(() => {
        dispatch(setForgetPassMailSent(true));
        dispatch(fetchSuccess());
      }, 300);
    };
  },
  getSocialMediaIcons: () => {
    return <React.Fragment> </React.Fragment>;
  },
};

export default JWTAuth;
